import { MultiCharity } from '@lib/services'
import { type FC } from 'react'

export const TipTooltipContent: FC<{ charityID: string }> = ({ charityID }) => {
  // TODO: fix copy
  return <div>
    <p className="font-light">
    Your tip keeps the platform running smoothly, ensuring thousands can automate their giving and never miss the 10 days of Dhul Hijjah.
    </p>
    {charityID === MultiCharity.gb &&
      <p className="font-light">
        <br />
        Your tip is gift aid eligible and is received as a donation to our charitable entity:
        The MTD Fund is a restricted fund operating at Compassion for Creation, registered
        charitable organisation number 1204164. The gift aid from your tip donation will also
        be passed on to the fund.
      </p>}
    {charityID !== MultiCharity.gb && charityID?.endsWith('-uk') ? (
      <p className="font-light">
        <br />
        Your tip is gift aid eligible and is received as a donation to our charitable entity:
        The Shamaazi Foundation, a restricted fund operating at Mercy Mission UK, registered
        charitable organisation number 1122922. The gift aid from your tip donation will also
        be passed on to the fund.
      </p>
    ) : null}
  </div>
}
